import React from "react";
import { Phone, Clock } from "lucide-react";
import Reveal from "../Reveal";
import LeadForm from "../forms/LeadForm";
import { studio } from "../../mock";

/** Contact form at the bottom of the home page. Messages land in the admin inbox as "Contact". */
const ContactSection = () => (
  <section className="relative border-t border-border bg-card/40 py-24 lg:py-32" id="contact" data-testid="contact-section">
    <div className="container-x grid gap-14 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-5">
        <Reveal>
          <p className="eyebrow">Say hello</p>
        </Reveal>
        <Reveal delay={80}>
          <h2 className="display mt-6 text-[clamp(3.5rem,8vw,8rem)] uppercase leading-[0.85] tracking-wide">
            Send us
            <br />
            <span className="text-stroke">a message</span>
          </h2>
        </Reveal>
        <Reveal delay={160}>
          <p className="mt-8 max-w-md text-base leading-relaxed text-muted-foreground md:text-lg">
            Questions about a piece, pricing, cover-ups or availability? Drop us a line and the studio will get back to you. Ready to book? Reach your artist directly from the Artists page.
          </p>
        </Reveal>
        <Reveal delay={240} className="mt-10 grid gap-6 border-t border-border pt-8 text-sm sm:grid-cols-2">
          <div className="flex gap-4">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center border border-border text-primary">
              <Phone className="h-4 w-4" />
            </span>
            <div>
              <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-muted-foreground">Prefer to call</p>
              <a href={studio.phoneHref} className="mt-2 block font-medium hover:text-primary">{studio.phone}</a>
            </div>
          </div>
          <div className="flex gap-4">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center border border-border text-primary">
              <Clock className="h-4 w-4" />
            </span>
            <div>
              <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-muted-foreground">Studio hours</p>
              <p className="mt-2 font-medium">
                {studio.hours.label}, {studio.hours.open} – {studio.hours.close}
              </p>
            </div>
          </div>
        </Reveal>
      </div>

      <Reveal delay={120} className="lg:col-span-7">
        <div className="border border-border bg-card p-7 md:p-10">
          <div className="mb-8 flex items-end justify-between gap-4">
            <h3 className="display text-4xl uppercase leading-none tracking-wide md:text-5xl">Contact the studio</h3>
            <span className="text-[10px] font-semibold uppercase tracking-[0.24em] text-muted-foreground">* required</span>
          </div>
          <LeadForm
            formType="contact"
            requireMessage
            submitLabel="Send message"
            successTitle="Message sent"
            successBody="Thanks for reaching out. Someone from Avalon will reply as soon as they can."
            messagePlaceholder="Tell us about the piece, placement, size, or anything you'd like to ask."
            testId="contact-form"
          />
        </div>
      </Reveal>
    </div>
  </section>
);

export default ContactSection;
